// extracted by mini-css-extract-plugin
module.exports = {"quizList":"QuizList_quizList__1D07d","error":"QuizList_error__mcWmt"};